// import RulePack from './RulePack';

export default {
  priority: 2,
  path: "packet",
  permissions: ["RequestsMenu/RequestPattern/PatternDefinitionMenu"],
  // component: RulePack,
  component: load(() =>
    import(/* webpackChunkName: "Request-pattern-RulePack" */ "./RulePack")
  ),
  name: app.translate(" احکام حقوق و دستمزد"),
  icon: "content-paste",
  drawer: true,
};
